import React, { useEffect, useRef, useState } from "react";
import SuggestionList from "../Offline/ProductLists/SuggestionList";
import { getSupplierSuggestions } from "../../../utils/apis/orders/supplierSearch";

let debounceTimer;

const SupplierSearchInput = ({ currentName, onSelect, disabled = false }) => {
  const [keyword, setKeyword] = useState(currentName || "");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setKeyword(currentName || "");
  }, [currentName]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (e) => {
    if (disabled) return;
    const value = e.target.value;
    setKeyword(value);
    setShowDropdown(true);
    setHighlightedIndex(-1);

    clearTimeout(debounceTimer);
    if (!value) {
      setSuggestions([]);
      return;
    }
    setLoading(true);
    debounceTimer = setTimeout(async () => {
      try {
        const results = await getSupplierSuggestions(value);
        setSuggestions(results);
      } catch (error) {
        console.error("Supplier search error:", error);
        setSuggestions([]);
      } finally {
        setLoading(false);
      }
    }, 300);
  };

  const handleSelect = (supplier) => {
    if (disabled) return;
    setKeyword(supplier.name);
    setShowDropdown(false);
    setSuggestions([]);
    onSelect(supplier);
  };

  return (
    <div ref={wrapperRef} style={{ position: "relative", minWidth: "160px" }}>
      <input
        type="text"
        className="form-control form-control-sm"
        value={keyword}
        placeholder="Search supplier"
        disabled={disabled}
        onChange={handleChange}
        onFocus={() => !disabled && keyword && setShowDropdown(true)}
      />
      {!disabled && showDropdown && keyword && (
        <div
          className="supplier-suggestions-wrapper"
          style={{ position: "absolute", zIndex: 20, minWidth: "280px" }}
        >
          <style>{`
            .supplier-suggestions-wrapper .smart-search-suggestions-list {
              max-height: 170px !important;
            }
          `}</style>
          <SuggestionList
            suggestions={suggestions}
            loading={loading}
            keyword={keyword}
            highlightedIndex={highlightedIndex}
            onHover={setHighlightedIndex}
            onSelect={handleSelect}
          />
        </div>
      )}
    </div>
  );
};

export default SupplierSearchInput;